import { render } from "./TagManageDialog.vue?vue&type=template&id=32917ae4&scoped=true"
import script from "./TagManageDialog.vue?vue&type=script&lang=js"
export * from "./TagManageDialog.vue?vue&type=script&lang=js"

import "./TagManageDialog.vue?vue&type=style&index=0&id=32917ae4&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32917ae4"]])

export default __exports__